const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Surveys Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Surveys', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v3/surveys/:subresource/:subsubresource/:subsubsubresource', null, {
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'PATCH', isArray: false},
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    list: {params: {subresource: ''}, method: 'GET', isArray: true},
    archive: {params: {subresource: 'archive'}, method: 'POST', isArray: false},
    submit: {params: {subresource: 'results', subsubresource: ''}, method: 'POST', isArray: false},
    getResult: {params: {subresource: '', subsubresource: 'result', subsubsubresource: ''}, method: 'GET', isArray: false},
    getResults: {params: {subresource: '', subsubresource: 'results'}, method: 'GET', isArray: true},
  });
  
}]);